// extracted by mini-css-extract-plugin
export default {"header":"Header_header__zXk6k","main-image":"Header_main-image__B+W3h"};